import { t } from "i18next";
import React from "react";
import { useState, useEffect } from "react";
import Button from "../../UI/Buttons/Button";
import "./CancellationAndWinbacks.scss"
import usePageTitle from '../../../Hooks/usePageTitle';
import useBodyClass from '../../../Hooks/useBodyClass';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'html-react-parser';
import { GenericErrorBox } from "../../UI/ErrorBox/GenericErrorBox";
import { use } from "react";
import { useParams } from "react-router";
import { APIGet, APIPost } from "../../API/APIRequest";
import { Loading } from "../../Utilities/Loading";
import { format } from "react-string-format";
import DOMPurify from 'dompurify';

export function Reactivation(props) {
    const { t, i18n } = useTranslation();
    useBodyClass(['cancelation', props.brandingElement?.bodyClass]);
    usePageTitle(`Reactivation -  ${props.brandingElement?.id}`);
    const [reactivationDetails, setReactivationDetails] = useState({});
    const [canReactivate, setCanReactivate] = useState("");
    const [errors, setErrors] = useState([]);
    const [isLoading, setIsLoading] = useState({button: false, page: true});
    const { fid } = useParams();

    const termsText = props.brandingElement?.termsText || '';

        const getReactivationDetails = () => {
    
        APIGet({

            "controller": "order",
            "action": "reactivationdetails",
            "identifier": fid

        })
            .then((response) => {
            
                console.log(response?.data);
                let data= response?.data;
                setCanReactivate(data?.canReactivate);
                setReactivationDetails(data?.reactivationDetails);
                setIsLoading({button: false, page: false});

            }).catch((error) => {
            
               var unexpected = [];
               unexpected.push("error.unexpected");
               setErrors(unexpected);
               setIsLoading({button: false, page: false});
            })
    }

    const reactivateOrder = () => {

        setIsLoading({button: true, page: false});
         APIPost({

            "controller": "order",
            "action": "reactivationsub",
            "data": { "fid": fid },
            "content_type": "json"

        }).then((response)=>{
            
                window.location.href= reactivationDetails?.returnUrl;
        }

        ).catch( (error) => {

                var unexpected = [];
                unexpected.push("error.unexpected");
                setErrors(unexpected);
                setIsLoading({button: false, page: false});

            });

    }

    useEffect(() => {

        getReactivationDetails();

    }, []);

    return (<>

         { errors.length > 0  ?
         
          <div className="container-wrapper one-column">
            <GenericErrorBox errors={errors} /> 
        </div>
         
         : isLoading.page ? <Loading loading = {isLoading} /> 
         
         : !canReactivate   ?

          <div className="container-wrapper one-column">
            <GenericErrorBox errors={t("reactivation.periodexpired")} />
         </div>

        : canReactivate  &&

        <div className="container-wrapper center-text">

            <div className="container">
                <div className="item-container">
                    <div className="item-wrapper">
                        <h2>{format(t("reactivation.heading"), reactivationDetails?.orderNumber)}</h2>
                    </div>
                </div>
                <div className="item-container">
                    <div className="item-wrapper">
                        <p>{t("reactivation.subtext")}</p>
                        <p>{t("reactivation.datetext")}</p>
                        <h2>{reactivationDetails?.nextPaymentDate}</h2>
                    </div>
                </div>
                <div className="item-container">
                    <div className="border-seperator"></div>
                </div>

                <div className="item-container">
                    <div className="item-wrapper">
                         {reactivationDetails.isDirectDebit === "True" ?  <p>{t('retentionoffer.chargeyouraccounttext')}</p> : <p>{t('retentionoffer.chargeyourcardtext')}</p>}
                        <p><strong>{reactivationDetails?.currencySymbol}{reactivationDetails?.nextPaymentAmount}</strong>{reactivationDetails?.paymentFrequency ? `/${reactivationDetails?.paymentFrequency}`: ""}</p>
                    </div>

                     <div className="item-wrapper center-flex-row" >
                    {reactivationDetails?.isDirectDebit === "True" ?
                        <div className="box-border">
                            <div className="payment-method">
                                <img src={`/assets/paymenttypes/logos/` + "directdebit" + `.svg`}
                                    alt="logo" />
                            </div>
                            <strong>xxxxx{reactivationDetails?.accountNumber.slice(-3)}</strong>
                        </div> :
                        (reactivationDetails?.creditCardTypeName?.toLowerCase() === "link" ) ?
                        <div className="box-border">
                            <div className="payment-method">
                                <img src={`/assets/paymenttypes/logos/link.svg`}
                                    alt="Stripe Link" />
                            </div>
                            <strong>Link Payment</strong>
                        </div> :
                        <div className="box-border">
                            <div className="payment-method">
                                <img src={`/assets/paymenttypes/logos/` + reactivationDetails?.creditCardTypeName + `.svg`}
                                    alt="logo" />
                            </div>
                            <strong>xxxx xxxx xxxx {reactivationDetails?.cardLast4}</strong>
                        </div>
                    }
                </div>
                </div>
                
                  <div className="item-container">
                      <div className="item-wrapper" >
                          <p className="meta">{ReactHtmlParser(DOMPurify.sanitize(termsText || ""))}</p>
                      </div>
                   </div>

                <div className="item-container">
                    <div className="item-wrapper center-flex-row">
                        {isLoading.button ? <Button type="button" buttonSize="small" hasIcon="updating">{t('reactivation.reactivateorderlabel')} </Button> :
                        <Button type="button" buttonSize="small" onClick={()=>{ reactivateOrder() }}>{t('reactivation.reactivateorderlabel')}</Button>
                        }
                    </div>
                </div>
            </div>

        </div>

       } 

    </>)

}



